import Yup from '../yup';

const conditions = {
  order_codes_sort: Yup.array()
    .ensure()
    .min(1, 'You must select at least one section or option on this page'),
};

export default conditions;
